export default {
  id: null,
  numero: null,
  descricao: null,
  gerenteId: null,
  funcionariosId: null,
  regionalId: null,
  codigoOmniChannel: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/pamodel.js